<script setup lang="ts">
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import type { HTMLAttributes } from 'vue'
import { cn } from '../utils'

interface Props {
  class?: HTMLAttributes['class']
  color?: string
  disabled?: boolean
  shape?: string
  size?: string
  type?: 'button' | 'submit' | 'reset'
}

const props = withDefaults(defineProps<Props>(), {
  color: 'white',
  shape: 'circular',
  size: 'sm',
  type: 'button',
})
</script>

<template>
  <ButtonBase
    :class="cn(props.class)"
    :color="props.color"
    :disabled="props.disabled"
    :shape="props.shape"
    :size="props.size"
    :type="props.type"
    v-bind="$attrs"
  >
    <slot />
  </ButtonBase>
</template>
